import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function phoneValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const valid = /^\+?[0-9\s\-()]{10,}$/.test(control.value); // Allows +, digits, spaces, dashes, and parentheses
    return valid ? null : { invalidPhone: { value: control.value } };
  };
}
